<div class="card card-tabs">
    <div class="card-body">
        <label for="" class="title-history">
			Ubicaciones/Destinos/Bodegas
		</label>
        <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="tab" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-list-squares"></i>Lista de Destinos
			</label>

			<input type="radio" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL" name="pcss3t" (click)="updateIndexParam(1)"
				[(ngModel)]="tab" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-group-arrows-rotate"></i>Asociación Destino/Bodegas
			</label>

			<input type="radio" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL" name="pcss3t" (click)="updateIndexParam(2)"
				[(ngModel)]="tab" [value]="2" id="tab3" class="tab-content-3">
			<label for="tab3" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-location-dot"></i>Ubicaciones
			</label>

			<input type="radio" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL" name="pcss3t" (click)="updateIndexParam(3)"
				[(ngModel)]="tab" [value]="3" id="tab4" class="tab-content-4">
			<label for="tab4" [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>Asociación Ubicación/Destino
			</label>

		</div>
        <div class="row" [hidden]="tab!=0">
			<div class="col" id="list-container">
                <app-destination-list *ngIf="tab==0"/>
			</div>
		</div>
		<div class="row" [hidden]="tab!=1">
			<div class="col" id="list-container">
				<app-association-destination-warehouses *ngIf="tab==1"/>
			</div>
		</div>
		<div class="row" [hidden]="tab!=2">
			<div class="col" id="list-container">
				<app-place-list *ngIf="tab==2"/>
			</div>
		</div>
		<div class="row" [hidden]="tab!=3">
			<div class="col" id="list-container">
				<app-association-place-destination *ngIf="tab==3"/>
			</div>
		</div>
    </div>
</div>